<template>
  <!-- eslint-disable max-len -->
  <div class="kws-quiz-solution">
    <ul>
      <li v-for="option in _options" :key="option.id">
        <div :class="{ 'selected': option.selected, 'valid': option.isValidAnswer }">
          <invalid v-if="!option.isValidAnswer"></invalid>
          <valid v-if="option.isValidAnswer"></valid>
          <div class="text">
            <p class="label">{{ option.label }}</p>
            <p
              class="hint"
              v-if="option.selected"
              v-text="option.isValidAnswer ? translate('lblAnswerCorrect') : translate('lblAnswerWrong')"
            ></p>
          </div>
        </div>
      </li>
    </ul>
    <p class="explanation">{{ solution.explanation }}</p>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import Valid from './symbol-valid.vue';
import Invalid from './symbol-invalid.vue';

export default {
  data: () => ({
    // eslint-disable-next-line vue/no-reserved-keys
    _options: null,
  }),
  props: {
    options: Array,
    solution: {
      type: Object,
      required: true,
    },
  },
  created() {
    // fires only for the first question (or last, if going back)
    this._options = this.options;
    if (this.solution.validAnswers && this.solution.validAnswers.length) {
      this._options.forEach((o) => {
        // eslint-disable-next-line no-param-reassign
        o.isValidAnswer = this.solution.validAnswers.includes(o.value);
      });
    }
  },
  components: {
    Valid,
    Invalid,
  },
};
</script>

<style scoped lang="scss">
.kws-quiz-solution {
  p {
    font-size: rem(15px);
    line-height: rem(18px);
    font-weight: bold;
    display: inline-block;

    &.label {
      font-weight: normal;
      margin-inline-end: rem(16px);
    }
  }

  li > div {
    padding: rem(8px);
    display: flex;
    align-items: flex-start;

    svg {
      margin-inline-end: rem(10px);
      width: rem(18px);
      height: rem(18px);
      flex: 0 0 rem(18px);
      fill: currentColor;
    }

    .text {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      flex-wrap: wrap;
    }

    p {
      margin: 0;
    }
  }

  .selected {
    color: $color-white;
    background-color: $color-kws-signalred-100;

    &.valid {
      background-color: $color-kws-green-100;
    }
  }
}
</style>
